import { fmtCompact } from "../kit";
import { icon } from "../iconsKit";
import { trophiesIcon } from "./econArt";

/**
 * The Trophy Hall's cosmetics in the Skins picker (MP-23): a Trophy Hall exclusive is never bought here — its card
 * shows its price in Trophies, and its one button opens the Hall on it (once the Hall registers its opener with
 * `setTrophyHallOpener`; until then the line "Trophy Hall · N Trophies" says where it is had).
 */

/** The Trophies currency mark: the painted gilt war-trophy token (`icons/res_trophies.png`). */
export function trophiesIconHtml(size = 16): string { return trophiesIcon(size); }

/** A Trophies price chip (the picker's card tag, the Hall button). */
export function trophyPriceHtml(amount: number, size = 16): string {
  return `<span class="price trophies">${trophiesIconHtml(size)}<b>${fmtCompact(amount)}</b></span>`;
}

/** The Trophy Hall opener: the Hall's page, on one cosmetic. Null until the Hall registers it. */
let opener: ((parent: HTMLElement, skinId: string) => void) | null = null;
export function setTrophyHallOpener(open: ((parent: HTMLElement, skinId: string) => void) | null): void { opener = open; }

/** Opens the Hall on `skinId`; false when the Hall is not wired (the picker then keeps its line). */
export function openTrophyHall(parent: HTMLElement, skinId: string): boolean {
  if (!opener) return false;
  opener(parent, skinId);
  return true;
}

/** The picker's button for a Trophy Hall exclusive: TROPHY HALL with its price (blue: the way there, not a purchase). */
export function trophyActionHtml(price: number): string {
  if (!opener) return `<div class="sk-lock th">${icon("lock", 16)}<span>Trophy Hall · ${price.toLocaleString("en-US")} Trophies</span></div>`;
  return `<button class="btn blue go th"><span class="disp">TROPHY HALL</span>${trophyPriceHtml(price, 16)}</button>`;
}
